import React, { useEffect, useState,useRef  } from "react"
import MetaTags from 'react-meta-tags';
import { apiEndpoint } from "helpers/url_helper";


import { connect } from "react-redux";
import {
    Col,
    Row,
    Card,
    CardBody,
    Button,
    Container,
    ButtonGroup,
    UncontrolledTooltip,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    ButtonDropdown,
    CardTitle,
} from "reactstrap"
import { setBreadcrumbItems } from "../../store/actions";
import MapContainer from "./MapContainer";
import CampusList from "./Campuslist";
import { CampusIdContext } from "components/Common/PageDataContext";
const Maps = (props) => {
    const breadcrumbItems = [
        // { title: "Lexa", link: "#" },
        //{ title: "Map", link: "#" }
      ]
      const [ selectedCampusval, setCampusValue ] = useState()
 
      const Contextvalue = {  selectedCampusval, setCampusValue };
      useEffect(() => {
        props.setBreadcrumbItems('Map', breadcrumbItems)
      
      })
    return (
        <React.Fragment>
            <MetaTags>
                <title>Indus |  Map</title>
            </MetaTags>
            <CampusIdContext.Provider value={Contextvalue}>
                <CampusList  setCampusValue={setCampusValue}></CampusList>     
                </CampusIdContext.Provider>         
        <br></br>           
         <MapContainer CampusID={selectedCampusval}></MapContainer>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(Maps);
